const TasksRouteNavigationOptions = {
  title: 'Tasks',
  headerTitle: 'Tasks',
  headerBackVisible: false,
};

export default TasksRouteNavigationOptions;
